import { ref } from "vue";
import { fabric } from "fabric";

import { addUserObject, getObjectProperty } from "@/canvas-api/Canvas";

export const svgShape = ref<fabric.Object>();
export const makeNewShape = (shape: string): void => {
  fabric.loadSVGFromURL(shape, function(results, options) {
    const obj = fabric.util.groupSVGElements(results, options) as fabric.Object;

    obj.id = 0;
    obj.originX = "center";
    obj.originY = "center";
    obj.name = "svgShape";
    obj.strokeWidth = 0;
    obj.stroke = "#0001ba";
    obj.opacity = 1;
    obj.fill = "#e6e6e6";

    addUserObject(obj);
  });
};

export const updateShape = (prop: string, value: string | boolean | number) => {
  getObjectProperty({ name: prop, value: value, });
};
